module.exports = __webpack_public_path__ + "static/img/partner_23.8583567.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/par/partner_23.png
// module id = zZNC
// module chunks = 0